module.exports = __webpack_public_path__ + "img/call-24px.4f6573b1.svg";